import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldCheck } from "lucide-react";

const CATEGORY_TILE = {
  Technical: "bg-skylight text-sky",
  Business: "bg-lemonlight text-[#8a6a10]",
  Creative: "bg-roselight text-rose",
  "Life Skills": "bg-tealight text-teal",
};

export default function CourseCard({ course, index = 0 }) {
  const tile = CATEGORY_TILE[course.category] || "bg-violetlight text-violet";
  return (
    <Link
      to={`/courses/${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className="group flex flex-col rounded-2xl overflow-hidden bg-surface border border-line shadow-sm hover:shadow-lg hover:-translate-y-1.5 transition duration-300"
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-stone">
        <img
          src={course.image}
          alt={course.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
        />
        <span className={`absolute top-3 left-3 font-sans text-xs font-bold px-3 py-1.5 rounded-full ${tile}`}>
          {course.category}
        </span>
        <span className="absolute top-3 right-3 inline-flex items-center gap-1 font-sans text-[11px] font-bold bg-surface/95 text-emerald px-2.5 py-1.5 rounded-full shadow-sm">
          <ShieldCheck size={12} /> Verified
        </span>
      </div>

      <div className="flex flex-col flex-1 p-6">
        <h3 className="font-display font-semibold tracking-tight text-xl leading-[1.2] group-hover:text-emerald transition-colors">
          {course.title}
        </h3>
        <p className="text-[15px] text-graphite mt-3 leading-relaxed line-clamp-2">
          {course.summary}
        </p>
        <div className="mt-auto pt-5 flex items-end justify-between gap-3 border-t border-line mt-5">
          <div className="pt-4">
            <p className="font-sans text-[11px] font-semibold text-graphite">
              Starting fee
            </p>
            <p className="font-display font-bold text-emerald text-xl mt-0.5">{course.starting_fee}</p>
          </div>
          <span className="mb-1 shrink-0 w-9 h-9 rounded-full bg-emeraldlight text-emerald flex items-center justify-center group-hover:bg-emerald group-hover:text-white transition-colors duration-300">
            <ArrowUpRight size={18} />
          </span>
        </div>
      </div>
    </Link>
  );
}
